export const GET_RISKS_OVERVIEW = 'overview.GET_RISKS_OVERVIEW'
export const SET_RISKS_OVERVIEW = 'overview.SET_RISKS_OVERVIEW'

export const GET_DIABETES_OVERVIEW = 'overview.GET_DIABETES_OVERVIEW'
export const SET_DIABETES_OVERVIEW = 'overview.SET_DIABETES_OVERVIEW'

export const GET_OVERWEIGHT_OVERVIEW = 'overview.GET_OVERWEIGHT_OVERVIEW'
export const SET_OVERWEIGHT_OVERVIEW = 'overview.SET_OVERWEIGHT_OVERVIEW'

export const GET_LIFEHABITS_OVERVIEW = 'overview.GET_LIFEHABITS_OVERVIEW'
export const SET_LIFEHABITS_OVERVIEW = 'overview.SET_LIFEHABITS_OVERVIEW'

export const GET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW = 'overview.GET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW'
export const SET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW = 'overview.SET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW'

export const GET_ENGAGEMENTBENEFICIARY_OVERVIEW = 'overview.GET_ENGAGEMENTBENEFICIARY_OVERVIEW'
export const SET_ENGAGEMENTBENEFICIARY_OVERVIEW = 'overview.SET_ENGAGEMENTBENEFICIARY_OVERVIEW'
export const GET_EQUIPEMENT_OVERVIEW = 'overview.GET_EQUIPEMENT_OVERVIEW'
export const SET_EQUIPEMENT_OVERVIEW = 'overview.SET_EQUIPEMENT_OVERVIEW'

export const getDiabetesOverview = (params, callback) => ({
  type: GET_DIABETES_OVERVIEW,
  params,
  callback
})

export const setDiabetesOverview = (diabetesData) => ({
  type: SET_DIABETES_OVERVIEW,
  diabetesData
})

export const getOverweightOverview = (params, callback) => ({
  type: GET_OVERWEIGHT_OVERVIEW,
  params,
  callback
})

export const setOverweightOverview = (overweightData) => ({
  type: SET_OVERWEIGHT_OVERVIEW,
  overweightData
})

export const getLifeHabitsOverview = (params, callback) => ({
  type: GET_LIFEHABITS_OVERVIEW,
  params,
  callback
})

export const setLifeHabitsOverview = (lifeHabitsData) => ({
  type: SET_LIFEHABITS_OVERVIEW,
  lifeHabitsData
})

export const getHypertensionAndDyslipidemiaOverview = (params, callback) => ({
  type: GET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW,
  params,
  callback
})

export const setHypertensionAndDyslipidemiaOverview = (hypertensionAndDyslipidemiaData) => ({
  type: SET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW,
  hypertensionAndDyslipidemiaData
})

export const getRisksOverview = (params, callback) => ({
  type: GET_RISKS_OVERVIEW,
  params,
  callback
})

export const setRisksOverview = (risksData) => ({
  type: SET_RISKS_OVERVIEW,
  risksData
})

export const getEngagementBeneficiaryOverview = (params, callback) => ({
  type: GET_ENGAGEMENTBENEFICIARY_OVERVIEW,
  params,
  callback
})

export const getEquipmentOverview = (params, callback) => ({
  type: GET_EQUIPEMENT_OVERVIEW,
  params,
  callback
})

export const setEngagementBeneficiaryOverview = (engagementBeneficiaryData) => ({
  type: SET_ENGAGEMENTBENEFICIARY_OVERVIEW,
  engagementBeneficiaryData

})

export const setEquipmentOverview = (equipmentData) => ({
  type: SET_EQUIPEMENT_OVERVIEW,
  equipmentData
})
